// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_heading {
  margin: 0;
  text-align: left;
  padding: 0 1vw;
  background-image: linear-gradient(to left, #fff, #2c53a0);
  color: #fff;
  position: sticky;
  top: 0px;
  z-index: 1000;
  display: flex;
  justify-content: "center";
  align-items: "center";
  flex-direction: "row";
  gap: "10px";
}
@media (max-width: 1000px) {
  .main_heading {
    font-size: 1.5rem;
  }
}
@media (max-width: 600px) {
  .main_heading {
    font-size: 1.2rem;
  }
}

.sub_heading {
  margin: 0;
}

.empty_table_heading {
  font-size: 3rem;
  padding: 5vh 5vw;
  background: -webkit-linear-gradient(#2c53a0, #2c53a0, #64c4e0);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.header_details {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 1vw;
  flex-wrap: wrap;
  width: 88vw;
  margin: 2vh auto;
  padding: 1vh 1vw;
}
.header_details div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  gap: "10px";
  width: 27vw;
  padding: 0 1vw;
  box-shadow: 0 4px 2px -2px #2c53a0;
  border-radius: 3px;
}
@media (max-width: 1000px) {
  .header_details div {
    width: 40vw;
  }
}
@media (max-width: 600px) {
  .header_details div {
    width: 95vw;
  }
}
.header_details div h3 {
  color: #2c53a0;
}
.header_details div h3,
.header_details div h4 {
  margin: 0;
}

.filter_container {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: row;
  gap: 1vw;
  flex-wrap: wrap;
  margin: 2vh auto;
  width: 98vw;
}
.filter_container select,
.filter_container input {
  border-radius: 3px;
  width: 30vw;
  min-width: 30vw;
  height: 4vh;
  border: 2px solid #2c53a0;
  background-color: #fff;
  color: #000;
}
.filter_container button {
  border-radius: 3px;
  width: 30vw;
  min-width: 30vw;
  height: 4vh;
}
@media (max-width: 600px) {
  .filter_container {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
    gap: 1vw;
  }
  .filter_container select,
  .filter_container input,
  .filter_container button {
    width: 95vw;
  }
}

.table {
  width: 95vw;
  font-size: 0.9em;
  font-family: sans-serif;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
  margin: 2vh auto;
  table-layout: fixed;
}
.table thead {
  height: 4vh;
}
.table thead tr {
  background-color: #2c53a0;
  color: #ffffff;
  text-align: left;
}
.table thead tr th {
  text-align: center;
}
.table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.table tbody tr:first-of-type {
  border-top: 2px solid #2c53a0;
}
.table tbody tr:last-of-type {
  border-bottom: 2px solid #2c53a0;
}
.table tbody tr td {
  padding: 12px 15px;
  word-wrap: break-word;
}
.table tbody tr td .input_number {
  border-radius: 3px;
  border: 2px solid #2c53a0;
  width: 50px;
  height: 3vh;
  text-align: center;
}
.table tbody tr td input::-webkit-outer-spin-button,
.table tbody tr td input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
@media (max-width: 1000px) {
  .table {
    display: block;
  }
  .table thead {
    height: 0;
    display: block;
  }
  .table thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .table thead tr th {
    display: block;
  }
  .table tbody {
    display: block;
  }
  .table tbody tr {
    display: block;
    margin-bottom: 0.5vh;
    border: 1px solid #ccc;
  }
  .table tbody tr td {
    display: block;
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
  }
  .table tbody tr td:before {
    position: absolute;
    top: 10px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
    font-weight: 700;
    text-align: left;
  }
}

.alert_modal {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1vh;
}
.alert_modal .alert_message {
  width: 92%;
}
.alert_modal button {
  width: 100%;
}

.confirm_modal {
  text-align: center;
}
.confirm_modal h4 {
  font-weight: 500;
  font-size: 1.2rem;
}
.confirm_modal .button_section {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 1vw;
}
.confirm_modal .button_section button {
  width: 100%;
}

.loader {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  border: 3px solid;
  border-color: #64c4e0 #64c4e0 transparent transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin: 5vh;
}

.loader::after,
.loader::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  border: 3px solid;
  border-color: transparent transparent #2c53a0 #2c53a0;
  width: 75px;
  height: 75px;
  border-radius: 50%;
  box-sizing: border-box;
  animation: rotationBack 0.5s linear infinite;
  transform-origin: center center;
}

.loader::before {
  width: 50px;
  height: 50px;
  border-color: #64c4e0 #64c4e0 transparent transparent;
  animation: rotation 1.5s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes rotationBack {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/reuseables.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAWA;EACI,SAAA;EACA,gBAAA;EACA,cAAA;EACA,yDAAA;EACA,WCTI;EDUJ,gBAAA;EACA,QAAA;EACA,aAAA;ECUA,aAAA;EACA,yBDVc;ECWd,qBDXwB;ECYxB,qBANY;EAOZ,WANM;ADbV;AAOI;EAVJ;IAWQ,iBAAA;EAJN;AACF;AAKI;EAbJ;IAcQ,iBAAA;EAFN;AACF;;AAIA;EACI,SAAA;AADJ;;AAGA;EACI,eAAA;EACA,gBAAA;EACA,8DAAA;EACA,6BAAA;EACA,qBAAA;EACA,oCAAA;AAAJ;;AAGA;ECXI,aAAA;EACA,uBDWc;ECVd,mBDUsB;ECTtB,mBDS8B;ECR9B,QDQmC;EACnC,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAIJ;AAHI;ECjBA,aAAA;EACA,8BDiBkB;EChBlB,mBDgBiC;ECfjC,mBDeyC;ECdzC,WANM;EDqBF,WAAA;EAOA,cAAA;EAEA,kCAAA;EACA,kBAAA;AAER;AAXQ;EAHJ;IAIQ,WAAA;EAcV;AACF;AAbQ;EANJ;IAOQ,WAAA;EAgBV;AACF;AAXQ;EACI,cC3DA;ADwEZ;AAXQ;;EAEI,SAAA;AAaZ;;AATA;ECvCI,aAAA;EACA,6BDuCc;ECtCd,mBDsC4B;ECrC5B,mBDqCoC;ECpCpC,QDoCyC;EACzC,eAAA;EACA,gBAAA;EACA,WAAA;AAgBJ;AAfI;;EAEI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,sBCzEA;ED0EA,WCzEA;AD0FR;AAfI;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AAiBR;AAfI;EArBJ;ICvCI,aAAA;IACA,6BD4DkB;IC3DlB,mBD2DgC;IC1DhC,sBD0DwC;ICzDxC,QDyDgD;EAsBlD;EArBM;;;IAGI,WAAA;EAuBV;AACF;;AAnBA;EACI,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,wCAAA;EACA,gBAAA;EACA,mBAAA;AAsBJ;AArBI;EACI,WAAA;AAuBR;AAtBQ;EACI,yBC5GA;ED6GA,cAAA;EACA,gBAAA;AAwBZ;AAvBY;EACI,kBAAA;AAyBhB;AAnBQ;EACI,gCAAA;AAqBZ;AAnBY;EACI,yBAAA;AAqBhB;AAnBY;EACI,6BAAA;AAqBhB;AAnBY;EACI,gCAAA;AAqBhB;AAlBY;EACI,kBAAA;EACA,qBAAA;AAoBhB;AAnBgB;EACI,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AAqBpB;AAnBgB;;EAEI,wBAAA;EACA,SAAA;AAqBpB;AAhBI;EAnDJ;IAoDQ,cAAA;EAmBN;EAjBM;IACI,SAAA;IACA,cAAA;EAmBV;EAlBU;IACI,kBAAA;IACA,YAAA;IACA,aAAA;EAoBd;EAnBc;IACI,cAAA;EAqBlB;EAhBM;IACI,cAAA;EAkBV;EAjBU;IACI,cAAA;IACA,oBAAA;IACA,sBAAA;EAmBd;EAlBc;IACI,cAAA;IACA,YAAA;IACA,6BAAA;IACA,kBAAA;IACA,iBAAA;EAoBlB;EAjBc;IACI,kBAAA;IACA,SAAA;IACA,SAAA;IACA,UAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;EAmBlB;AACF;;AAbA;ECtKI,aAAA;EACA,uBDsKc;ECrKd,mBDqKsB;ECpKtB,sBDoK8B;ECnK9B,QDmKsC;AAoB1C;AAlBI;EACI,UAAA;AAoBR;AAlBI;EACI,WAAA;AAoBR;;AAhBA;EACI,kBAAA;AAmBJ;AAjBI;EACI,gBAAA;EACA,iBAAA;AAmBR;AAhBI;ECzLA,aAAA;EACA,uBDyLkB;ECxLlB,mBDwL0B;ECvL1B,mBDuLkC;ECtLlC,QDsLuC;AAsB3C;AArBQ;EACI,WAAA;AAuBZ;;AAlBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qDAAA;EACA,sBAAA;EACA,sCAAA;EACA,WAAA;AAqBJ;;AAnBA;;EAEI,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,qDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,4CAAA;EACA,+BAAA;AAsBJ;;AApBA;EACI,WAAA;EACA,YAAA;EACA,qDAAA;EACA,wCAAA;AAuBJ;;AApBA;EACI;IACI,uBAAA;EAuBN;EArBE;IACI,yBAAA;EAuBN;AACF;AArBA;EACI;IACI,uBAAA;EAuBN;EArBE;IACI,0BAAA;EAuBN;AACF","sourcesContent":["@import \"./variables.scss\";\n\n//? These presets should be used were the following features on a page are present::after\n\n//? MAIN HEADING\n//? EMPTY TABLE HEADING\n//? HEADER INFORMATION\n//? FILTERS\n//? TABLE\n//? DIFFERENT STYLED BUTTONS\n\n.main_heading {\n    margin: 0;\n    text-align: left;\n    padding: 0 1vw;\n    background-image: linear-gradient(to left, $white, $nitroDark);\n    color: $white;\n    position: sticky;\n    top: 0px;\n    z-index: 1000;\n    @include flex(\"center\", \"center\");\n    @media (max-width: $tablet) {\n        font-size: 1.5rem;\n    }\n    @media (max-width: $mobile) {\n        font-size: 1.2rem;\n    }\n}\n.sub_heading {\n    margin: 0;\n}\n.empty_table_heading {\n    font-size: 3rem;\n    padding: 5vh 5vw;\n    background: -webkit-linear-gradient($nitroDark, $nitroDark, $nitroLight);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n.header_details {\n    @include flex(center, center, row, 1vw);\n    flex-wrap: wrap;\n    width: 88vw;\n    margin: 2vh auto;\n    padding: 1vh 1vw;\n    div {\n        @include flex(space-between, center, row);\n        width: 27vw;\n        @media (max-width: $tablet) {\n            width: 40vw;\n        }\n        @media (max-width: $mobile) {\n            width: 95vw;\n        }\n        padding: 0 1vw;\n\n        box-shadow: 0 4px 2px -2px $nitroDark;\n        border-radius: 3px;\n        h3 {\n            color: $nitroDark;\n        }\n        h3,\n        h4 {\n            margin: 0;\n        }\n    }\n}\n.filter_container {\n    @include flex(space-evenly, center, row, 1vw);\n    flex-wrap: wrap;\n    margin: 2vh auto;\n    width: 98vw;\n    select,\n    input {\n        border-radius: 3px;\n        width: 30vw;\n        min-width: 30vw;\n        height: 4vh;\n        border: 2px solid $nitroDark;\n        background-color: $white;\n        color: $black;\n    }\n    button {\n        border-radius: 3px;\n        width: 30vw;\n        min-width: 30vw;\n        height: 4vh;\n    }\n    @media (max-width: $mobile) {\n        @include flex(space-evenly, center, column, 1vw);\n        select,\n        input,\n        button {\n            width: 95vw;\n        }\n    }\n}\n\n.table {\n    width: 95vw;\n    font-size: 0.9em;\n    font-family: sans-serif;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);\n    margin: 2vh auto;\n    table-layout: fixed;\n    thead {\n        height: 4vh;\n        tr {\n            background-color: $nitroDark;\n            color: #ffffff;\n            text-align: left;\n            th {\n                text-align: center;\n            }\n        }\n    }\n\n    tbody {\n        tr {\n            border-bottom: 1px solid #dddddd;\n\n            &:nth-of-type(even) {\n                background-color: #f3f3f3;\n            }\n            &:first-of-type {\n                border-top: 2px solid $nitroDark;\n            }\n            &:last-of-type {\n                border-bottom: 2px solid $nitroDark;\n            }\n\n            td {\n                padding: 12px 15px;\n                word-wrap: break-word;\n                .input_number {\n                    border-radius: 3px;\n                    border: 2px solid $nitroDark;\n                    width: 50px;\n                    height: 3vh;\n                    text-align: center;\n                }\n                input::-webkit-outer-spin-button,\n                input::-webkit-inner-spin-button {\n                    -webkit-appearance: none;\n                    margin: 0;\n                }\n            }\n        }\n    }\n    @media (max-width: $tablet) {\n        display: block;\n\n        thead {\n            height: 0;\n            display: block;\n            tr {\n                position: absolute;\n                top: -9999px;\n                left: -9999px;\n                th {\n                    display: block;\n                }\n            }\n        }\n\n        tbody {\n            display: block;\n            tr {\n                display: block;\n                margin-bottom: 0.5vh;\n                border: 1px solid #ccc;\n                td {\n                    display: block;\n                    border: none;\n                    border-bottom: 1px solid #eee;\n                    position: relative;\n                    padding-left: 50%;\n                }\n\n                td:before {\n                    position: absolute;\n                    top: 10px;\n                    left: 6px;\n                    width: 45%;\n                    padding-right: 10px;\n                    white-space: nowrap;\n                    font-weight: 700;\n                    text-align: left;\n                }\n            }\n        }\n    }\n}\n\n.alert_modal {\n    @include flex(center, center, column, 1vh);\n\n    .alert_message {\n        width: 92%;\n    }\n    button {\n        width: 100%;\n    }\n}\n\n.confirm_modal {\n    text-align: center;\n\n    h4 {\n        font-weight: 500;\n        font-size: 1.2rem;\n    }\n\n    .button_section {\n        @include flex(center, center, row, 1vw);\n        button {\n            width: 100%;\n        }\n    }\n}\n\n.loader {\n    width: 90px;\n    height: 90px;\n    border-radius: 50%;\n    display: inline-block;\n    position: relative;\n    border: 3px solid;\n    border-color: $nitroLight $nitroLight transparent transparent;\n    box-sizing: border-box;\n    animation: rotation 1s linear infinite;\n    margin: 5vh;\n}\n.loader::after,\n.loader::before {\n    content: \"\";\n    box-sizing: border-box;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    border: 3px solid;\n    border-color: transparent transparent $nitroDark $nitroDark;\n    width: 75px;\n    height: 75px;\n    border-radius: 50%;\n    box-sizing: border-box;\n    animation: rotationBack 0.5s linear infinite;\n    transform-origin: center center;\n}\n.loader::before {\n    width: 50px;\n    height: 50px;\n    border-color: $nitroLight $nitroLight transparent transparent;\n    animation: rotation 1.5s linear infinite;\n}\n\n@keyframes rotation {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n@keyframes rotationBack {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(-360deg);\n    }\n}\n","//Colors\n$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n$white: #fff;\n$black: #000;\n$success: #b6fcc9;\n$green: #357a38;\n\n//Heights\n$nav-height: 10vh;\n$main-height: 89vh;\n$footer-height: 6vh;\n\n//Breakpoints\n$mobile: 600px;\n$tablet: 1000px;\n$desktop: 1300px;\n\n//Layout\n@mixin flex(\n    $justify: \"center\",\n    $align: \"center\",\n    $direction: \"row\",\n    $gap: \"10px\"\n) {\n    display: flex;\n    justify-content: $justify;\n    align-items: $align;\n    flex-direction: $direction;\n    gap: $gap;\n}\n\n//Overflow\n@mixin scrollbars(\n    $size,\n    $foreground-color,\n    $background-color: mix($foreground-color, white, 50%)\n) {\n    // For Google Chrome\n    &::-webkit-scrollbar {\n        width: $size;\n        height: $size;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: $foreground-color;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $background-color;\n    }\n\n    // For Internet Explorer\n    & {\n        scrollbar-face-color: $foreground-color;\n        scrollbar-track-color: $background-color;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
